"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_course_attendance_html_1 = __importDefault(require("./admin-course-attendance.html"));
var admin_course_attendance_controller_1 = __importDefault(require("./admin-course-attendance.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.courses.attendance", {
        url: "/attendance/:courseId",
        template: admin_course_attendance_html_1.default,
        controller: admin_course_attendance_controller_1.default,
        controllerAs: "vm",
        resolve: {
            course: getCourse,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
function getCourse($stateParams, CoursesModel) {
    return CoursesModel.show($stateParams.courseId).then(function (response) {
        return response.course;
    });
}
getCourse.$inject = ["$stateParams", "CoursesModel"];
exports.default = angular_1.default
    .module("admin.dashboard.course.attendance", [])
    .config(config)
    .controller("AdminCourseAttendanceController", admin_course_attendance_controller_1.default);
